// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg viewBox=%270 0 24 24%27 fill=%27currentColor%27%3E%3Cpath d=%27M12,1L3,5V11C3,16.55 6.84,21.74 12,23C17.16,21.74 21,16.55 21,11V5L12,1M12,7C13.4,7 14.8,8.6 14.8,10.5V11.5C15.4,11.5 16,12.4 16,13V16C16,16.6 15.6,17 15,17H9C8.4,17 8,16.6 8,16V13C8,12.4 8.4,11.5 9,11.5V10.5C9,8.6 10.6,7 12,7M12,8.2C11.2,8.2 10.2,8.7 10.2,10.5V11.5H13.8V10.5C13.8,8.7 12.8,8.2 12,8.2Z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3Csvg viewBox=%270 0 20 20%27 fill=%27currentColor%27%3E%3Cpath fillRule=%27evenodd%27 d=%27M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z%27 clipRule=%27evenodd%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  backdrop-filter: blur(4px);
}

.twofa-modal {
  background: white;
  border-radius: var(--radius-xl);
  width: 90%;
  max-width: 500px;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: var(--shadow-xl);
  animation: slideIn var(--transition-base) ease-out;
}

@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateY(-20px) scale(0.95);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

.twofa-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: var(--spacing-lg) var(--spacing-xl);
  border-bottom: 1px solid var(--color-gray-200);
  background: linear-gradient(135deg, var(--color-gray-50) 0%, white 100%);
  border-radius: var(--radius-xl) var(--radius-xl) 0 0;
}

.twofa-header h2 {
  margin: 0;
  color: var(--color-secondary);
  font-size: var(--font-size-xl);
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: var(--spacing-sm);
}

.twofa-header h2::before {
  content: '';
  width: 24px;
  height: 24px;
  background: linear-gradient(135deg, var(--color-secondary), var(--color-secondary-light));
  mask: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) center/contain no-repeat;
  -webkit-mask: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) center/contain no-repeat;
}

.close-button {
  background: none;
  border: none;
  font-size: 24px;
  color: var(--color-gray-500);
  cursor: pointer;
  padding: var(--spacing-sm);
  border-radius: var(--radius-md);
  transition: all var(--transition-fast);
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.close-button:hover {
  background: var(--color-gray-200);
  color: var(--color-gray-700);
}

.twofa-content {
  padding: var(--spacing-xl);
}

.twofa-info {
  text-align: center;
  margin-bottom: var(--spacing-lg);
}

.security-icon, .email-sent-icon {
  margin-bottom: var(--spacing-md);
  display: flex;
  justify-content: center;
  align-items: center;
}

.security-shield-icon, .email-icon {
  width: 48px;
  height: 48px;
  color: var(--color-secondary);
}

.warning-icon {
  width: 16px;
  height: 16px;
  margin-right: var(--spacing-xs);
  flex-shrink: 0;
}

.twofa-info h3 {
  color: var(--color-secondary);
  margin-bottom: var(--spacing-sm);
  font-size: var(--font-size-lg);
}

.twofa-info p {
  color: var(--color-gray-600);
  margin-bottom: var(--spacing-lg);
}

.email-info {
  background: linear-gradient(135deg, var(--color-gray-50) 0%, white 100%);
  padding: var(--spacing-md);
  border-radius: var(--radius-md);
  margin-bottom: var(--spacing-lg);
  text-align: left;
  border: 1px solid var(--color-gray-200);
}

.email-info strong {
  color: var(--color-secondary);
  font-size: var(--font-size-sm);
}

.email-display {
  background: white;
  padding: var(--spacing-sm) var(--spacing-md);
  border-radius: var(--radius-sm);
  border: 1px solid var(--color-gray-200);
  margin-top: var(--spacing-sm);
  font-family: 'Monaco', 'Consolas', monospace;
  font-size: var(--font-size-sm);
  color: var(--color-secondary);
  text-align: center;
}

.benefits-list {
  text-align: left;
  background: linear-gradient(135deg, rgba(16, 185, 129, 0.05) 0%, rgba(16, 185, 129, 0.02) 100%);
  padding: var(--spacing-md);
  border-radius: var(--radius-md);
  border: 1px solid rgba(16, 185, 129, 0.1);
}

.benefits-list h4 {
  margin: 0 0 var(--spacing-sm) 0;
  color: var(--color-secondary);
  font-size: var(--font-size-base);
}

.benefits-list ul {
  list-style: none;
  margin: 0;
  padding: 0;
}

.benefits-list li {
  padding: var(--spacing-xs) 0;
  color: var(--color-gray-600);
  font-size: var(--font-size-sm);
  display: flex;
  align-items: center;
  gap: var(--spacing-sm);
}

.benefit-icon {
  color: var(--color-success);
  font-weight: bold;
  font-size: var(--font-size-lg);
  line-height: 1;
}

.verification-step {
  text-align: center;
}

.verification-step h3 {
  color: var(--color-secondary);
  margin-bottom: var(--spacing-sm);
}

.verification-step p {
  color: var(--color-gray-600);
  margin-bottom: var(--spacing-md);
}

.code-input-section {
  margin: var(--spacing-lg) 0;
}

.code-input-section label {
  display: block;
  margin-bottom: var(--spacing-sm);
  color: var(--color-secondary);
  font-weight: 500;
  font-size: var(--font-size-sm);
}

.code-input {
  width: 100%;
  max-width: 200px;
  padding: var(--spacing-md);
  border: 2px solid var(--color-gray-300);
  border-radius: var(--radius-md);
  font-size: var(--font-size-xl);
  text-align: center;
  letter-spacing: 8px;
  font-family: 'Inter', 'Monaco', 'Consolas', monospace;
  transition: all var(--transition-fast);
  background: linear-gradient(135deg, white 0%, var(--color-gray-50) 100%);
  font-weight: 600;
}

.code-input:focus {
  outline: none;
  border-color: var(--color-primary);
  box-shadow: 0 0 0 3px rgba(255, 107, 53, 0.1);
}

.helper-text {
  margin-top: var(--spacing-md);
}

.helper-text p {
  font-size: var(--font-size-sm);
  color: var(--color-gray-500);
  margin: 0;
}

.error-message {
  background: linear-gradient(135deg, rgba(239, 68, 68, 0.08) 0%, rgba(239, 68, 68, 0.04) 100%);
  color: var(--color-danger);
  padding: var(--spacing-md);
  border-radius: var(--radius-md);
  margin: var(--spacing-md) 0;
  font-size: var(--font-size-sm);
  text-align: center;
  border: 1px solid rgba(239, 68, 68, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--spacing-sm);
}

.error-message::before {
  content: '';
  width: 16px;
  height: 16px;
  background: var(--color-danger);
  mask: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) center/contain no-repeat;
  -webkit-mask: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) center/contain no-repeat;
  flex-shrink: 0;
}

.error-text {
  color: var(--color-danger);
  font-size: var(--font-size-sm);
  margin-top: var(--spacing-sm);
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--spacing-xs);
}

.twofa-actions {
  display: flex;
  gap: var(--spacing-md);
  justify-content: flex-end;
  margin-top: var(--spacing-xl);
  padding-top: var(--spacing-lg);
  border-top: 1px solid var(--color-gray-200);
}

.twofa-actions button {
  min-width: 120px;
  padding: var(--spacing-sm) var(--spacing-lg);
}

.dev-helper {
  background: var(--color-gray-100);
  color: var(--color-gray-600);
  padding: var(--spacing-sm);
  text-align: center;
  font-size: var(--font-size-xs);
  border-radius: 0 0 var(--radius-xl) var(--radius-xl);
  margin-top: var(--spacing-md);
  border-top: 1px solid var(--color-gray-200);
}

@media (max-width: 600px) {
  .twofa-modal {
    width: 95%;
    margin: var(--spacing-md);
  }
  
  .twofa-actions {
    flex-direction: column;
  }
  
  .twofa-actions button {
    width: 100%;
  }
}

/* Enhanced verification step styling */
.verification-step {
  background: linear-gradient(135deg, rgba(59, 130, 246, 0.03) 0%, rgba(59, 130, 246, 0.01) 100%) !important;
  padding: var(--spacing-lg) !important;
  border-radius: var(--radius-lg) !important;
  border: 1px solid rgba(59, 130, 246, 0.1) !important;
  margin-bottom: var(--spacing-lg) !important;
}

/* Success state styling */
.twofa-success {
  background: linear-gradient(135deg, rgba(16, 185, 129, 0.05) 0%, rgba(16, 185, 129, 0.02) 100%);
  border: 1px solid rgba(16, 185, 129, 0.2);
  color: var(--color-success);
  padding: var(--spacing-lg);
  border-radius: var(--radius-lg);
  text-align: center;
  margin: var(--spacing-lg) 0;
}

/* Professional button enhancements */
.twofa-actions .btn-primary {
  background: linear-gradient(135deg, var(--color-primary) 0%, var(--color-primary-dark) 100%);
  box-shadow: 0 4px 12px rgba(255, 107, 53, 0.3);
  font-weight: 600;
}

.twofa-actions .btn-primary:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 6px 16px rgba(255, 107, 53, 0.4);
}

.twofa-actions .btn-secondary {
  background: linear-gradient(135deg, white 0%, var(--color-gray-50) 100%);
  font-weight: 500;
}
`, "",{"version":3,"sources":["webpack://./src/components/TwoFactorSetup.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,4BAA4B;EAC5B,kDAAkD;AACpD;;AAEA;EACE;IACE,UAAU;IACV,wCAAwC;EAC1C;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,4CAA4C;EAC5C,8CAA8C;EAC9C,wEAAwE;EACxE,oDAAoD;AACtD;;AAEA;EACE,SAAS;EACT,6BAA6B;EAC7B,8BAA8B;EAC9B,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,yFAAyF;EACzF,sEAAkb;EAClb,8EAA0b;AAC5b;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,4BAA4B;EAC5B,eAAe;EACf,0BAA0B;EAC1B,+BAA+B;EAC/B,sCAAsC;EACtC,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,iCAAiC;EACjC,4BAA4B;AAC9B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;EAChC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,cAAc;AAChB;;AAEA;EACE,6BAA6B;EAC7B,gCAAgC;EAChC,8BAA8B;AAChC;;AAEA;EACE,4BAA4B;EAC5B,gCAAgC;AAClC;;AAEA;EACE,wEAAwE;EACxE,0BAA0B;EAC1B,+BAA+B;EAC/B,gCAAgC;EAChC,gBAAgB;EAChB,uCAAuC;AACzC;;AAEA;EACE,6BAA6B;EAC7B,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;EACjB,4CAA4C;EAC5C,+BAA+B;EAC/B,uCAAuC;EACvC,6BAA6B;EAC7B,4CAA4C;EAC5C,8BAA8B;EAC9B,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,+FAA+F;EAC/F,0BAA0B;EAC1B,+BAA+B;EAC/B,yCAAyC;AAC3C;;AAEA;EACE,+BAA+B;EAC/B,6BAA6B;EAC7B,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,4BAA4B;EAC5B,4BAA4B;EAC5B,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;EAC3B,iBAAiB;EACjB,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,gCAAgC;AAClC;;AAEA;EACE,4BAA4B;EAC5B,gCAAgC;AAClC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,gCAAgC;EAChC,6BAA6B;EAC7B,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,0BAA0B;EAC1B,uCAAuC;EACvC,+BAA+B;EAC/B,8BAA8B;EAC9B,kBAAkB;EAClB,mBAAmB;EACnB,qDAAqD;EACrD,sCAAsC;EACtC,wEAAwE;EACxE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,6CAA6C;AAC/C;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,8BAA8B;EAC9B,4BAA4B;EAC5B,SAAS;AACX;;AAEA;EACE,6FAA6F;EAC7F,0BAA0B;EAC1B,0BAA0B;EAC1B,+BAA+B;EAC/B,2BAA2B;EAC3B,8BAA8B;EAC9B,kBAAkB;EAClB,wCAAwC;EACxC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,sEAA2R;EAC3R,8EAAmS;EACnS,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,8BAA8B;EAC9B,6BAA6B;EAC7B,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,6BAA6B;EAC7B,8BAA8B;EAC9B,2CAA2C;AAC7C;;AAEA;EACE,gBAAgB;EAChB,4CAA4C;AAC9C;;AAEA;EACE,iCAAiC;EACjC,4BAA4B;EAC5B,0BAA0B;EAC1B,kBAAkB;EAClB,8BAA8B;EAC9B,oDAAoD;EACpD,6BAA6B;EAC7B,2CAA2C;AAC7C;;AAEA;EACE;IACE,UAAU;IACV,yBAAyB;EAC3B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;AACF;;AAEA,uCAAuC;AACvC;EACE,0GAA0G;EAC1G,qCAAqC;EACrC,0CAA0C;EAC1C,oDAAoD;EACpD,2CAA2C;AAC7C;;AAEA,0BAA0B;AAC1B;EACE,+FAA+F;EAC/F,yCAAyC;EACzC,2BAA2B;EAC3B,0BAA0B;EAC1B,+BAA+B;EAC/B,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA,qCAAqC;AACrC;EACE,4FAA4F;EAC5F,8CAA8C;EAC9C,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,wEAAwE;EACxE,gBAAgB;AAClB","sourcesContent":[".modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  backdrop-filter: blur(4px);\n}\n\n.twofa-modal {\n  background: white;\n  border-radius: var(--radius-xl);\n  width: 90%;\n  max-width: 500px;\n  max-height: 90vh;\n  overflow-y: auto;\n  box-shadow: var(--shadow-xl);\n  animation: slideIn var(--transition-base) ease-out;\n}\n\n@keyframes slideIn {\n  from {\n    opacity: 0;\n    transform: translateY(-20px) scale(0.95);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n}\n\n.twofa-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: var(--spacing-lg) var(--spacing-xl);\n  border-bottom: 1px solid var(--color-gray-200);\n  background: linear-gradient(135deg, var(--color-gray-50) 0%, white 100%);\n  border-radius: var(--radius-xl) var(--radius-xl) 0 0;\n}\n\n.twofa-header h2 {\n  margin: 0;\n  color: var(--color-secondary);\n  font-size: var(--font-size-xl);\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-sm);\n}\n\n.twofa-header h2::before {\n  content: '';\n  width: 24px;\n  height: 24px;\n  background: linear-gradient(135deg, var(--color-secondary), var(--color-secondary-light));\n  mask: url(\"data:image/svg+xml,%3Csvg viewBox='0 0 24 24' fill='currentColor'%3E%3Cpath d='M12,1L3,5V11C3,16.55 6.84,21.74 12,23C17.16,21.74 21,16.55 21,11V5L12,1M12,7C13.4,7 14.8,8.6 14.8,10.5V11.5C15.4,11.5 16,12.4 16,13V16C16,16.6 15.6,17 15,17H9C8.4,17 8,16.6 8,16V13C8,12.4 8.4,11.5 9,11.5V10.5C9,8.6 10.6,7 12,7M12,8.2C11.2,8.2 10.2,8.7 10.2,10.5V11.5H13.8V10.5C13.8,8.7 12.8,8.2 12,8.2Z'/%3E%3C/svg%3E\") center/contain no-repeat;\n  -webkit-mask: url(\"data:image/svg+xml,%3Csvg viewBox='0 0 24 24' fill='currentColor'%3E%3Cpath d='M12,1L3,5V11C3,16.55 6.84,21.74 12,23C17.16,21.74 21,16.55 21,11V5L12,1M12,7C13.4,7 14.8,8.6 14.8,10.5V11.5C15.4,11.5 16,12.4 16,13V16C16,16.6 15.6,17 15,17H9C8.4,17 8,16.6 8,16V13C8,12.4 8.4,11.5 9,11.5V10.5C9,8.6 10.6,7 12,7M12,8.2C11.2,8.2 10.2,8.7 10.2,10.5V11.5H13.8V10.5C13.8,8.7 12.8,8.2 12,8.2Z'/%3E%3C/svg%3E\") center/contain no-repeat;\n}\n\n.close-button {\n  background: none;\n  border: none;\n  font-size: 24px;\n  color: var(--color-gray-500);\n  cursor: pointer;\n  padding: var(--spacing-sm);\n  border-radius: var(--radius-md);\n  transition: all var(--transition-fast);\n  width: 40px;\n  height: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.close-button:hover {\n  background: var(--color-gray-200);\n  color: var(--color-gray-700);\n}\n\n.twofa-content {\n  padding: var(--spacing-xl);\n}\n\n.twofa-info {\n  text-align: center;\n  margin-bottom: var(--spacing-lg);\n}\n\n.security-icon, .email-sent-icon {\n  margin-bottom: var(--spacing-md);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.security-shield-icon, .email-icon {\n  width: 48px;\n  height: 48px;\n  color: var(--color-secondary);\n}\n\n.warning-icon {\n  width: 16px;\n  height: 16px;\n  margin-right: var(--spacing-xs);\n  flex-shrink: 0;\n}\n\n.twofa-info h3 {\n  color: var(--color-secondary);\n  margin-bottom: var(--spacing-sm);\n  font-size: var(--font-size-lg);\n}\n\n.twofa-info p {\n  color: var(--color-gray-600);\n  margin-bottom: var(--spacing-lg);\n}\n\n.email-info {\n  background: linear-gradient(135deg, var(--color-gray-50) 0%, white 100%);\n  padding: var(--spacing-md);\n  border-radius: var(--radius-md);\n  margin-bottom: var(--spacing-lg);\n  text-align: left;\n  border: 1px solid var(--color-gray-200);\n}\n\n.email-info strong {\n  color: var(--color-secondary);\n  font-size: var(--font-size-sm);\n}\n\n.email-display {\n  background: white;\n  padding: var(--spacing-sm) var(--spacing-md);\n  border-radius: var(--radius-sm);\n  border: 1px solid var(--color-gray-200);\n  margin-top: var(--spacing-sm);\n  font-family: 'Monaco', 'Consolas', monospace;\n  font-size: var(--font-size-sm);\n  color: var(--color-secondary);\n  text-align: center;\n}\n\n.benefits-list {\n  text-align: left;\n  background: linear-gradient(135deg, rgba(16, 185, 129, 0.05) 0%, rgba(16, 185, 129, 0.02) 100%);\n  padding: var(--spacing-md);\n  border-radius: var(--radius-md);\n  border: 1px solid rgba(16, 185, 129, 0.1);\n}\n\n.benefits-list h4 {\n  margin: 0 0 var(--spacing-sm) 0;\n  color: var(--color-secondary);\n  font-size: var(--font-size-base);\n}\n\n.benefits-list ul {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n\n.benefits-list li {\n  padding: var(--spacing-xs) 0;\n  color: var(--color-gray-600);\n  font-size: var(--font-size-sm);\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-sm);\n}\n\n.benefit-icon {\n  color: var(--color-success);\n  font-weight: bold;\n  font-size: var(--font-size-lg);\n  line-height: 1;\n}\n\n.verification-step {\n  text-align: center;\n}\n\n.verification-step h3 {\n  color: var(--color-secondary);\n  margin-bottom: var(--spacing-sm);\n}\n\n.verification-step p {\n  color: var(--color-gray-600);\n  margin-bottom: var(--spacing-md);\n}\n\n.code-input-section {\n  margin: var(--spacing-lg) 0;\n}\n\n.code-input-section label {\n  display: block;\n  margin-bottom: var(--spacing-sm);\n  color: var(--color-secondary);\n  font-weight: 500;\n  font-size: var(--font-size-sm);\n}\n\n.code-input {\n  width: 100%;\n  max-width: 200px;\n  padding: var(--spacing-md);\n  border: 2px solid var(--color-gray-300);\n  border-radius: var(--radius-md);\n  font-size: var(--font-size-xl);\n  text-align: center;\n  letter-spacing: 8px;\n  font-family: 'Inter', 'Monaco', 'Consolas', monospace;\n  transition: all var(--transition-fast);\n  background: linear-gradient(135deg, white 0%, var(--color-gray-50) 100%);\n  font-weight: 600;\n}\n\n.code-input:focus {\n  outline: none;\n  border-color: var(--color-primary);\n  box-shadow: 0 0 0 3px rgba(255, 107, 53, 0.1);\n}\n\n.helper-text {\n  margin-top: var(--spacing-md);\n}\n\n.helper-text p {\n  font-size: var(--font-size-sm);\n  color: var(--color-gray-500);\n  margin: 0;\n}\n\n.error-message {\n  background: linear-gradient(135deg, rgba(239, 68, 68, 0.08) 0%, rgba(239, 68, 68, 0.04) 100%);\n  color: var(--color-danger);\n  padding: var(--spacing-md);\n  border-radius: var(--radius-md);\n  margin: var(--spacing-md) 0;\n  font-size: var(--font-size-sm);\n  text-align: center;\n  border: 1px solid rgba(239, 68, 68, 0.2);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: var(--spacing-sm);\n}\n\n.error-message::before {\n  content: '';\n  width: 16px;\n  height: 16px;\n  background: var(--color-danger);\n  mask: url(\"data:image/svg+xml,%3Csvg viewBox='0 0 20 20' fill='currentColor'%3E%3Cpath fillRule='evenodd' d='M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z' clipRule='evenodd'/%3E%3C/svg%3E\") center/contain no-repeat;\n  -webkit-mask: url(\"data:image/svg+xml,%3Csvg viewBox='0 0 20 20' fill='currentColor'%3E%3Cpath fillRule='evenodd' d='M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z' clipRule='evenodd'/%3E%3C/svg%3E\") center/contain no-repeat;\n  flex-shrink: 0;\n}\n\n.error-text {\n  color: var(--color-danger);\n  font-size: var(--font-size-sm);\n  margin-top: var(--spacing-sm);\n  text-align: center;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: var(--spacing-xs);\n}\n\n.twofa-actions {\n  display: flex;\n  gap: var(--spacing-md);\n  justify-content: flex-end;\n  margin-top: var(--spacing-xl);\n  padding-top: var(--spacing-lg);\n  border-top: 1px solid var(--color-gray-200);\n}\n\n.twofa-actions button {\n  min-width: 120px;\n  padding: var(--spacing-sm) var(--spacing-lg);\n}\n\n.dev-helper {\n  background: var(--color-gray-100);\n  color: var(--color-gray-600);\n  padding: var(--spacing-sm);\n  text-align: center;\n  font-size: var(--font-size-xs);\n  border-radius: 0 0 var(--radius-xl) var(--radius-xl);\n  margin-top: var(--spacing-md);\n  border-top: 1px solid var(--color-gray-200);\n}\n\n@media (max-width: 600px) {\n  .twofa-modal {\n    width: 95%;\n    margin: var(--spacing-md);\n  }\n  \n  .twofa-actions {\n    flex-direction: column;\n  }\n  \n  .twofa-actions button {\n    width: 100%;\n  }\n}\n\n/* Enhanced verification step styling */\n.verification-step {\n  background: linear-gradient(135deg, rgba(59, 130, 246, 0.03) 0%, rgba(59, 130, 246, 0.01) 100%) !important;\n  padding: var(--spacing-lg) !important;\n  border-radius: var(--radius-lg) !important;\n  border: 1px solid rgba(59, 130, 246, 0.1) !important;\n  margin-bottom: var(--spacing-lg) !important;\n}\n\n/* Success state styling */\n.twofa-success {\n  background: linear-gradient(135deg, rgba(16, 185, 129, 0.05) 0%, rgba(16, 185, 129, 0.02) 100%);\n  border: 1px solid rgba(16, 185, 129, 0.2);\n  color: var(--color-success);\n  padding: var(--spacing-lg);\n  border-radius: var(--radius-lg);\n  text-align: center;\n  margin: var(--spacing-lg) 0;\n}\n\n/* Professional button enhancements */\n.twofa-actions .btn-primary {\n  background: linear-gradient(135deg, var(--color-primary) 0%, var(--color-primary-dark) 100%);\n  box-shadow: 0 4px 12px rgba(255, 107, 53, 0.3);\n  font-weight: 600;\n}\n\n.twofa-actions .btn-primary:hover:not(:disabled) {\n  transform: translateY(-1px);\n  box-shadow: 0 6px 16px rgba(255, 107, 53, 0.4);\n}\n\n.twofa-actions .btn-secondary {\n  background: linear-gradient(135deg, white 0%, var(--color-gray-50) 100%);\n  font-weight: 500;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
